import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight, Rocket } from "lucide-react";

export default function CategoryCard({ category }) {
    const Icon = Icons[category.icon] || Icons.Package;
    const isOpportunity = !!category.has_opportunity;

    return (
        <Link
            to={`/category/${category.slug}`}
            className={`group bg-white rounded-2xl p-5 card-lift block focus:outline-none focus:ring-2 focus:ring-saffron/40 border ${
                isOpportunity
                    ? "border-saffron/40 bg-gradient-to-br from-white to-saffron-50/40"
                    : "border-line"
            }`}
            data-testid={`category-card-${category.slug}`}
        >
            <div className="flex items-start justify-between gap-3">
                <div className="h-11 w-11 rounded-xl bg-saffron-50 text-saffron flex items-center justify-center group-hover:bg-saffron group-hover:text-white transition-colors">
                    <Icon className="h-5 w-5" strokeWidth={2.2} />
                </div>
                {isOpportunity ? (
                    <span
                        className="text-xs font-semibold text-white bg-saffron border border-saffron rounded-full px-2.5 py-0.5 inline-flex items-center gap-1"
                        data-testid={`opportunity-badge-${category.slug}`}
                    >
                        <Rocket className="h-3 w-3" /> Opportunity
                    </span>
                ) : (
                    <span className="text-xs font-semibold text-indiagreen-700 bg-indiagreen-50 border border-indiagreen-200 rounded-full px-2.5 py-0.5">
                        {category.product_count}
                    </span>
                )}
            </div>
            <h3 className="mt-4 font-heading font-bold text-ink text-base leading-snug">
                {category.name}
            </h3>
            <p className="mt-1.5 text-sm text-ink-muted line-clamp-2 leading-relaxed">
                {isOpportunity
                    ? "No Indian alternative yet — the market is wide open."
                    : category.description || ""}
            </p>
            <div className="mt-4 inline-flex items-center text-sm font-semibold text-saffron opacity-0 group-hover:opacity-100 transition-opacity">
                {isOpportunity ? "Build for Bharat" : "Explore"}{" "}
                <ArrowRight className="h-4 w-4 ml-1" />
            </div>
        </Link>
    );
}
